import { useLoginVerify } from './useLoginVerify';

export function useIsUngated(gate: string): boolean {
  const { data: loginVerifyData } = useLoginVerify();
  return loginVerifyData?.featuresEnabled?.includes(gate) ?? false;
}
